import React from 'react';
import moment from 'moment';

interface CardSummarySignatureProps {
  title: string;
  valor_total: string;
  inicio: string;
  fim: string;
  paymentCondition: string;
  parcela: string | number;
  formas_pagamento: string;
  statusPayment: number;
  valorParcela: string | number;
}

const CardSummarySignature = (props: CardSummarySignatureProps) => {
  const {
    title,
    valor_total,
    inicio,
    fim,
    paymentCondition,
    parcela,
    formas_pagamento,
    statusPayment,
    valorParcela,
  } = props;

  return (
    <div className="mb-4">
      <h4 className="font-weight-bold">{title}</h4>
      <div className="card">
        <ul className="list-group list-group-flush">
          <li className="list-group-item">
            <div className="row mb-0">
              <div className="col-md-10" />
              <div className="col-md-2">
                <p className="mb-0 font-weight-bold text-right">{`R$ ${valor_total
                  .toString()
                  .replace('.', ',')
                  .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')}`}</p>
              </div>
            </div>
          </li>
          <li className="list-group-item">
            {' '}
            <div className="row mb-0">
              <div className="col-md-10">
                <p className="mb-0">Condição de pagamento</p>
              </div>
              <div className="col-md-2">
                <p className="mb-0 text-right">{`R$ ${paymentCondition
                  .toString()
                  .replace('.', ',')
                  .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')}`}</p>
              </div>
            </div>
          </li>
          <li className="list-group-item">
            {' '}
            <div className="row mb-0">
              <div className="col-md-10">
                <p className="mb-0">Valor final</p>
              </div>
              <div className="col-md-2">
                <p className="mb-0 text-right">{`R$ ${valor_total
                  .toString()
                  .replace('.', ',')
                  .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')}`}</p>
              </div>
            </div>
          </li>
          <li className="list-group-item">
            {' '}
            <div className="row mb-0">
              <div className="col-md-6">
                <p className="mb-0">Forma de pagamento</p>
              </div>
              <div className="col-md-6">
                <p className="mb-0 text-right">{`${parcela}x de ${parseFloat(
                  String(valorParcela),
                ).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })} no ${formas_pagamento}`}</p>
              </div>
            </div>
          </li>
          <li className="list-group-item">
            {' '}
            <div className="row mb-0">
              <div className="col-md-8">
                <p className="mb-0">Vigência</p>
              </div>
              <div className="col-md-4 text-right">
                <p>{`${moment(inicio).format('L')} à ${moment(fim).format('L')}`}</p>
              </div>
            </div>
          </li>
          <li className="list-group-item">
            {' '}
            <div className="row mb-0">
              <div className="col-md-8">
                <p className="mb-0">Status do pagamento</p>
              </div>
              <div className="col-md-4 text-right">
                <p>{statusPayment > 0 ? 'Pendente' : 'Pago'}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CardSummarySignature;
